module.exports = __webpack_public_path__ + "static/media/VRED Design.2a88371b.png";